import { render, staticRenderFns } from "./ManageTask.vue?vue&type=template&id=06d61c3b&scoped=true"
import script from "./ManageTask.vue?vue&type=script&lang=js"
export * from "./ManageTask.vue?vue&type=script&lang=js"
import style0 from "./ManageTask.vue?vue&type=style&index=0&id=06d61c3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d61c3b",
  null
  
)

export default component.exports